import React from "react";
import StageQuestionList from "../../Components/StageQuestionList";

const StageQuestions = () => {
  return <StageQuestionList />;
};

export default StageQuestions;
